"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ProductsList = _interopRequireDefault(require("./components/product-list/ProductsList"));

var _FiltersListComponent = _interopRequireDefault(require("./components/filters/FiltersListComponent"));

var _creators = require("../../../redux/creators");

var _utils = require("./../../../configuration/utils");

var _constans = require("./../../../configuration/constans");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InstrumentListComponent = function InstrumentListComponent(_ref) {
  var isAccessoriesList = _ref.isAccessoriesList,
      setFiltersParams = _ref.setFiltersParams,
      resetFetchInitialization = _ref.resetFetchInitialization;
  var dispatch = (0, _reactRedux.useDispatch)();
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  var pimDataStore = (0, _reactRedux.useSelector)(function (state) {
    return state.productList;
  });
  var pepFilters = (0, _reactRedux.useSelector)(function (state) {
    return state.pepFilters;
  });
  var activeProductsList = (0, _reactRedux.useSelector)(function (state) {
    return state.activeProducts;
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      pimData = _useState2[0],
      setPIMData = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      filtersReady = _useState4[0],
      setFilters = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      productListData = _useState6[0],
      setProductListData = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      dataResolved = _useState8[0],
      setDataResolved = _useState8[1]; // when you enter on productList without filters data in SPA then user will be redirected to proper Sitecore component- to refactor


  var shouldRedirect = function shouldRedirect() {
    var filtersComponent = document.querySelector(".".concat(_constans.initialState.pepAccListComponentName, ", .").concat(_constans.initialState.pepListComponentName));

    if (!filtersComponent) {
      var _document$querySelect;

      (_document$querySelect = document.querySelector(".".concat(_constans.initialState.pepDetailsComponentName))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add('skeleton-fake-list');
      var link = isAccessoriesList ? dictionary.accessoriesListPath : dictionary.instrumentListPath;
      window.location.pathname = link;
    }
  };

  (0, _react.useEffect)(function () {
    shouldRedirect();
  });
  var getProducts = (0, _react.useCallback)(function () {
    (0, _utils.getProductListWithSettings)(dictionary.settingsParam.params, dictionary.settingsParam.token, isAccessoriesList).then(function (pimData) {
      setDataResolved(true);

      if (!pimData) {
        resetFetchInitialization();
      } else {
        var properProductsList = !isAccessoriesList ? (0, _utils.preProcessForFilters)(pimData.hearingAids) : pimData.accessories;
        var PEPComponent = (0, _utils.getSitecoreData)(properProductsList, isAccessoriesList);

        PEPComponent.onRender = function (_ref2) {
          var component = _ref2.component,
              dataPromise = _ref2.dataPromise,
              pim = _ref2.pim,
              filters = _ref2.filters;
          setProductListData({
            component: component,
            pim: pim,
            dataPromise: dataPromise,
            filters: filters
          });
        };

        PEPComponent.run();
      }
    })["catch"](function (err) {
      console.error(err);
    });
  }, [dictionary, isAccessoriesList, _utils.getSitecoreData, resetFetchInitialization]);
  var setData = (0, _react.useCallback)(function () {
    try {
      dispatch((0, _creators.setPepFilters)(productListData === null || productListData === void 0 ? void 0 : productListData.filters));
      dispatch((0, _creators.setPimConfig)(productListData === null || productListData === void 0 ? void 0 : productListData.pim));
      productListData.dataPromise.then(function (cmsData) {
        dispatch((0, _creators.setProductList)(cmsData));
        (0, _utils.pepSkeletonLoader)("end");
      })["catch"](function (err) {
        console.error(err);
        (0, _utils.pepSkeletonLoader)("end");
      });
    } catch (e) {
      console.log('set Data error- ', e);
    }
  }, [dispatch, _creators.setPepFilters, _creators.setPimConfig, productListData]);
  (0, _react.useEffect)(function () {
    if (productListData) {
      setData();
    } else if (dataResolved) {
      setDataResolved(false);
      getProducts();
    }
  }, [productListData, getProducts, setDataResolved, setData]);
  (0, _react.useEffect)(function () {
    window.scrollTo(0, 0);
    (0, _utils.pepSkeletonLoader)("init");
    getProducts();
    return function () {
      setFilters(false);
      dispatch((0, _creators.setPepFilters)(null));
      dispatch((0, _creators.setPimConfig)(null));
      dispatch((0, _creators.setProductList)(null));
      setPIMData(false);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (pepFilters) {
      setFilters(true);
    }

    if (pimDataStore) {
      setPIMData(true);
    }
  }, [pimDataStore]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid-container flex-row"
  }, filtersReady && pimData && /*#__PURE__*/_react["default"].createElement(_FiltersListComponent["default"], {
    isAccessoriesList: isAccessoriesList,
    setFiltersParams: setFiltersParams
  }), activeProductsList && pimData && /*#__PURE__*/_react["default"].createElement(_ProductsList["default"], {
    isAccessoriesList: isAccessoriesList
  })));
};

var _default = InstrumentListComponent;
exports["default"] = _default;